export default {
    data: () => ({
        stockMovementColumns: [
            {
                label: "lending kit",
                field: "lending_kit.identifier",
                sortable: true,
                required: true
            },
            {
                label: "lending point",
                field: "lending_point.description",
                sortable: true,
                required: true
            },
            {
                label: "stock status",
                field: "stock_status.description",
                sortable: true,
                required: true
            },
            {
                label: "created at",
                field: "created_at",
                sortable: true,
                required: true
            },
            {
                label: "created by",
                field: "creator.name",
                sortable: true,
                required: true
            }
        ]
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/stockMovementColumns.js